var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hubConnectionEstablished)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("mdi-cloud")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v("mdi-cloud-off-outline")])}
var staticRenderFns = []

export { render, staticRenderFns }